import { createContext, useContext, PropsWithChildren, useState } from "react";

// @ts-ignore
export const UserContext = createContext();

type Props = {};

export function UserProvider({ children }: PropsWithChildren<Props>) {
  const [user, setUser] = useState(null);

  const logMeOut = (logoutFn: any) => {
    setUser(null);
    localStorage.removeItem("vault_token");
    logoutFn();
  };

  return (
    <UserContext.Provider value={{ user, setUser, logMeOut }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUserContext = () => useContext(UserContext);
